import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileSubmitForApprovalActions'

const initialState = {
  submitting: false,
  submitted: false
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case events.submit.submitting:
      newState.submittedProfile = false
      newState.submissionForApproval.submitting = true
      newState.submissionForApproval.submitted = false
      return newState
    case events.submit.submitted:
      newState.submissionForApproval.submitting = false
      newState.submissionForApproval.submitted = true
      newState.edited = false
      return newState
    case events.submit.failed:
      newState.submissionForApproval.submitting = false
      newState.submissionForApproval.submitted = false
      return newState
  }
  return state
}
